import { ModuleType } from './modules';

export type ModuleRestrict = {
  priv: string;
  limit: number;
  permitted: boolean;
};

export type InstallableModuleType = {
  moduleName: ModuleType;
  installedCount?: number;
  limit: number;
  restrict?: ModuleRestrict;
};

export interface SectionLayoutZone {
  installableModuleTypes: InstallableModuleType[];
  installedModulesIds: number[];
  isInstallingModule?: boolean;
  currentlyInstalledModulePostion?: number;
}

export enum ZoneType {
  NONE = 'none',
  TOP_BAR = 'topBar',
  TOP_LEFT = 'topLeft',
  MID_LEFT = 'midLeft',
  BOTTOM_LEFT = 'bottomLeft',
  TOP_RIGHT = 'topRight',
  MID_RIGHT = 'midRight',
  BOTTOM_RIGHT = 'bottomRight',
}

export interface SectionLayoutZones {
  topBar?: SectionLayoutZone;
  topLeft?: SectionLayoutZone;
  midLeft?: SectionLayoutZone;
  bottomLeft?: SectionLayoutZone;
  topRight?: SectionLayoutZone;
  midRight?: SectionLayoutZone;
  bottomRight?: SectionLayoutZone;
}

export interface SectionLayout {
  version: number;
  zones: SectionLayoutZones;
}

export interface Layout {
  [section: string]: SectionLayout;
}
